import { render, staticRenderFns } from "./associazioneStati.vue?vue&type=template&id=579daf55&"
import script from "./associazioneStati.vue.ts?vue&type=script&lang=ts&"
export * from "./associazioneStati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports